import { getInitialStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-initial-structure-nodeset";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";

export class CreateAncestorsLineageForSidePanel {
  createInitialStructureAncestorsLineageForSidePanel(nodeId: string) {
    const initialStructureNodeset = getInitialStructureNodeset();

    const initialFlatMap = initialStructureNodeset.getFlatMap();

    const initialNode = initialFlatMap.get(nodeId);

    const initialLocationAncestors = initialNode
      ? initialNode.createAncestorsList()
      : [];

    return initialLocationAncestors;
  }

  createMachineStructureAncestorsLineageForSidePanel(nodeId: string) {
    const machineStructureNodeset = getMachineStructureNodeset();

    const machineFlatMap = machineStructureNodeset.getFlatMap();

    const machineNode = machineFlatMap.get(nodeId);

    const machineLocationAncestors = machineNode
      ? machineNode.createAncestorsList()
      : [];

    return machineLocationAncestors;
  }
}
